import {
  WS_CLOSE_CODE_ABNORMAL_CLOSE,
  WS_CLOSE_CODE_GOING_AWAY,
  WS_CLOSE_CODE_NORMAL,
} from 'constants/websocket';
import * as loggerx from 'utilities/loggerx';

const WS_BAD_CLOSE_ERROR = 'websocket bad close code';

class Websocket {
  constructor(url) {
    this.websocket = new WebSocket(url);
    this.messageQueue = [];
    this.closeCode = null;
    this.onErrorHandler = null;
    this.onCloseHandler = () => {};

    this.close = this.close.bind(this);

    this.websocket.onclose = event => {
      const { code } = event;

      this.closeCode = code;

      this.onCloseHandler();

      if (code === WS_CLOSE_CODE_NORMAL) {
        return;
      }

      this.websocket = null;

      const badCloseError = Error(`${WS_BAD_CLOSE_ERROR}: ${code}`);

      if (this.onErrorHandler != null) {
        this.onErrorHandler(badCloseError, { code });
      }
    };
  }

  ready(onReady) {
    this.websocket.onopen = () => {
      onReady();

      // protect against orphaned websockets
      window.addEventListener('beforeunload', this.close);
      window.addEventListener('unload', this.close);
    };
  }

  onError(onError) {
    this.onErrorHandler = onError;
  }

  onMessage(onMessage) {
    this.websocket.onmessage = onMessage;
  }

  onClose(onCloseHandler) {
    this.onCloseHandler = onCloseHandler;
  }

  closedFromServerError() {
    return (
      this.closeCode === WS_CLOSE_CODE_ABNORMAL_CLOSE ||
      this.closeCode === WS_CLOSE_CODE_GOING_AWAY
    );
  }

  send(message) {
    if (this.websocket == null) {
      // websocket is closed
      return;
    }

    if (!window.navigator.onLine) {
      this.messageQueue.push(message);
      loggerx.info('no network connection', {
        queueLength: this.messageQueue.length,
      });

      return;
    }

    if (this.messageQueue.length > 0) {
      loggerx.debug('draining websocket message queue');

      this.messageQueue.forEach(messageToSend => {
        this.websocket.send(messageToSend);
      });

      this.messageQueue = [];
    }

    this.websocket.send(message);
  }

  close() {
    if (this.websocket != null) {
      this.websocket.close(WS_CLOSE_CODE_NORMAL);

      window.removeEventListener('beforeunload', this.close);
      window.removeEventListener('unload', this.close);
    }

    this.websocket = null;
  }
}

export default Websocket;
